import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { WizCheckbox, WizDatasource, WizEventManager, WizVgroup} from '@wizeoo/akm-component-lib';
import { FreeDataCartesianBuilder, VisionKey } from '@wizeoo/akm-message-lib';
import { FreedataValueVO } from  '../../../vo/core/freedatavalue.vo';
import { ALK_EVENT_TYPE, WIDGET_ACTION_ORIGIN, WIDGET_GLOBAL_KIND, WIDGET_KIND, WIDGET_STATE } from '../../../model/enums';
import { WidgetBasic } from '../base/widget-basic';

import { GeneratorSettingsPop } from '../generator/pop/generator-settings.pop';
import { ColDef, GridOptions} from 'ag-grid-community';
import { BaselineEngine, FeiKeyDef, KEY_KIND, WizConstants } from '@wizeoo/akm-compute-lib';
import { AlkEvent } from '../../../framework/events/alk.event';
import { VisionManageLinesCmd } from '../../../command/vision/vision-managelines.cmd';
import { ViewData } from '../../../model/view.data';
import { FreeDataVO } from '../../../vo/core/freedata.vo';
import { FreedataLevelVO } from '../../../vo/core/freedatalevel.vo';
import { IFreedataWidget, IWidget } from '../../../manager/widgets/i-widget';
import { GridsterWidget } from '../../../vo/workingzone/gridster-widget';
import { WizColDef } from '../../../manager/workingdata/fei.engine';

/**
 * conf d'un grid
 */
export interface generatorGridDatas {
  wizDatasource: WizDatasource<FreedataValueVO>; // données sources
  columnDefs: ColDef[]; // les colonnes pour affichage 
  filterDefs?: ColDef[]; // les colonnes pour filtre
  fdKey: string; // clé unique de la codif code#lvl
  fdLabel: string; // libellé de la codif pour rendu rapide du titre
  parentWidget: IWidget;
  requiredSize: number;
}


@Component({
  selector: 'generator-widget',
  templateUrl: './generator.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/** formulaire libre */
export class GeneratorWidget extends WidgetBasic implements AfterViewInit, OnDestroy {

  @ViewChild('cbshowAll', { read: WizCheckbox }) cbshowAll: WizCheckbox; // cbox voir tout
  @ViewChild('daddy', { read: WizVgroup }) daddy: WizVgroup; //container pour prise de taille

  public get daddySize(): number {
    // let res: number = this.elementRef.nativeElement.offsetHeight -30;
    let res: number = 50; //  -15 || 50;
    if(this.daddy) {
      const el = this.daddy.elementRef?.nativeElement;
      res = el.offsetHeight; //  -15;
    }    
    return res;
  }


  /**
   * constructeur
   * @param elementRef 
   * @param _cdRef 
   */
  constructor(elementRef: ElementRef, cdRef: ChangeDetectorRef) {
    super(elementRef, cdRef);

    this.widgetKind = WIDGET_KIND.GENERATOR; // Pivot ou Grid, sera déterminé par pivotMode
    this.widgetGlobalKind = WIDGET_GLOBAL_KIND.BASELINE;
  }

  public idxSet: Set<number> = new Set();

  // la map par indice pour la construction des grids
  public gridMap: Map<number, generatorGridDatas> = new Map();

  // la map des grids de steps inf par clé FDV pour alimenter correctement les FDV
  public sidegridMap: Map<number, generatorGridDatas> = new Map();



  // mode "voir tout"
  public showAll: boolean = false;


  // les indices de clés pour construire les agGrids pour chaque codif
  public get idxArr(): number[] {
    return [...this.gridMap?.keys() || []];
  }

  /**
   * accès aux données pour un grid
   * @param idx 
   * @returns 
   */
  public getData(idx: number): generatorGridDatas {
    // console.log('daddy', this.daddySize);
    return this.gridMap.get(idx);
  }

  /**
   * calcule la taille requise pour un grid
   * @param idx 
   * @returns 
   */
  public getRequiredSize(columnDefs: WizColDef[]): number {
    let result: number = 30; // colonne de sélection
    columnDefs.forEach(wcf => {
      let baseSize: number = wcf.wcio.csiz || 100;
      if(wcf.wcio.cauto) {
        baseSize = wcf.wcio.cmsiz || 100;
      }
      result+= baseSize;
    });
    return result;
  }

  public getSize(idx: number): string {
    return this.getData(idx).requiredSize + 'px';
  }


  /** définition des colonnes du grid */
  // public columns: (ColDef | ColGroupDef)[] = null;

  gridOptions: GridOptions = {
    suppressRowClickSelection: true,
    getRowNodeId: (params) => params?.code
  };


  public currentMasters: Map<string, GridsterWidget> = new Map(); // les maîtres par type de FD

  // construction de la map de widgets Masters pour alimentation des collections et construction des colonnes
  private buildMasters(): void {
    if (this.context.muid) {
      // maître alimenté
      let splitted: string[] = this.context.muid.split(ViewData.KEY_SEPARATOR);
      this.currentMasters = new Map();
      splitted.forEach(s => {
        let gw: GridsterWidget = this.model.widgetEngine.getWidgetByUid(s);
        if(!!gw) {
          this.currentMasters.set(gw.freedataCode, gw );
        }
      });
    }

  }

  /**
   * construction des colonnes, pour Override dans les toolPivots
   */
  public buildColumns(master: GridsterWidget = null): WizColDef[] {
    let columns: ColDef[] = [];
    
    if(!!master) {
      columns = this.model.feiEngine.buildFDGridColumns(master.instance as IFreedataWidget, master.instance.context, true, true);
    } else {
      columns = [
        {
          headerName: '$.field.parentcode.$',
          field: 'parentCode',
          width: 70,
          sortable: true,
          resizable: true,
        },
        {
          headerName: '$.field.shortcode.$',
          field: 'shortCode',
          width: 70,
          sortable: true,
          resizable: true,
        },
        {
          headerName: '$.field.label.$',
          field: 'trsLabel',
          flex: 1,
          sortable: true,
          resizable: true,
          tooltipField: 'trsLabel'
      }];
    }
    return columns as WizColDef[];
  }

  public async buildLines(): Promise<void> {
   super.buildLines(); // construit les lignes et alimente mainDS
   this.buildMasters();

   let key: FeiKeyDef = null;
   // une clé de vision
   let idx: number = 1;
   Object.values(this.vision.visionKeys).forEach((vk: VisionKey) => {
     
     if(vk.stepLevel <= this.fei.visionStepLevel) {
   
        key = BaselineEngine.buildFeiKeyDef(this.fei, KEY_KIND.KEY, vk);
        let imIn: boolean = false;
        let imSide: boolean = false; // je suis dedans, mais un parent
        if(!!this.currentMasters.has(key.code))  {
          imIn = true;
        }

        if(!!imIn) {

        if((this.currentMasters.get(key.code).instance as IFreedataWidget).level === key.level) { // même niveau
          // OK
        } else  {
          imSide = true;
        }

        // par défaut, tous les FDVs du Freedata
        let basePool: FreedataValueVO[];
         
        if(!imSide) { // même niveau
          basePool = (this.currentMasters.get(key.code).instance as IFreedataWidget).fdvDS.getWorkedSource();
          // console.log("same level", basePool);
        } else {
           basePool = this.model.freedataEngine.getFreedataValuesByLevel(key.fullCode);
           // console.log("other level", basePool);
        }
        
        // let basePool: FreedataValueVO[] = (this.currentMasters.get(key.code).instance as IFreedataWidget).fdvDS.getWorkedSource();
        
        if(this.currentMasters.has(key.code)) {
          if(!imSide) {
            // console.log('reduction', key.code);
            // réduction du périmètre par les masters
            basePool = this.model.widgetEngine.availableFreedataMasterLines(this, this.currentMasters.get(key.code).instance as IFreedataWidget, key.fullCode, basePool);

          } else {
            // side console.log('reduction on other', key.code);

            // on cherche à filtrer sur des enfants, il faut prendre le code parent (si écart 1 level)
            // on garde tout, on va les injecter
            // let refPool: FreedataValueVO[] = (this.currentMasters.get(key.code).instance as IFreedataWidget).fdvDS.getWorkedSource();
            // let refDad: Set<string> = new Set(refPool.map(item => item.parentCode));
            // let finalPool :  FreedataValueVO[] = [];
            // basePool.forEach(dad => {
            //   if(refDad.has(dad.code)) {
            //     finalPool.push(dad);
            //   }
            // });

            // // réduction du périmètre par les enfants
            // basePool = finalPool;

          }

          

        } else {
          // passe jamais ici
          // console.log('im notIN', key.code);
          // console.log('no such master', key.code);
        }

 
        //#### ici, application des restrictions sur chaque FDV.restrict
        let realBasePool: FreedataValueVO[] = []; // le pool qu'on va altérer
  
        let imOut: boolean; // oups, je suis exclus
        let hasOne: boolean; // indicateur pour chaque codif de restriction

        let restrictObj: any; // l'objet restriction
        let restrictFD: string; // le FD cible pour cette restriction
        let restrictLevel: number; // le niveau cible pour cette restriction
        let restrictSet: Set<string>; // les valeurs acceptables pour cette restriction

        // pour chaque élément encore dans le pool
        basePool.forEach( fdv => {

          if(!!fdv.restrict) { // seulement s'il y a une restriction

            imOut = false; // par  défaut, je suis admis
            restrictObj = JSON.parse(fdv.restrict); // construction de l'objet

            // pour chaque entrée dans le fdv.restrict
            Object.keys(restrictObj).forEach(rkey => {
              restrictFD = rkey.split(ViewData.CONTEXT_SEPARATOR)[0];
              restrictLevel = Number(rkey.split(ViewData.CONTEXT_SEPARATOR)[1]);
              restrictSet = new Set(restrictObj[rkey]);
              hasOne = false;
              if(this.currentMasters.has(restrictFD) && !this.showAll) { // il existe un master sur le même FD
                let mmast: IFreedataWidget = this.currentMasters.get(restrictFD).instance as IFreedataWidget;
                
                if ( mmast.fdvDS?.selectedItems?.length > 0) { // si le master à une sélection
                  mmast.fdvDS.selectedItems.forEach(selectFDV => {
                    let dad: FreedataValueVO = selectFDV; // le FDV sélectionné dans le master
                    // OK si c'est le même niveau..

                    // si le step du master est plus "bas" (level >) que ma restriction
                    if(mmast.level > restrictLevel) { // je vais prendre ses valeurs pour le niveau recherché       
                      while(dad?.level > restrictLevel &&  !!dad?.parentCode) {
                        dad = dad.getParentVO();
                      }
                    } 
                    // else if(mmast.level < restrictLevel) { // master moins précis, je regarde si c'est un parent d'au moins l'une de mes valeurs
  
                    // }
  
                    if(!!restrictSet.has(dad?.shortCode)) {
                      hasOne = true; // on a trouvé quelque chose, c'est OK (au moins pour ce FD)
                    }
                  });
                  
                  if(!hasOne) { // rien trouvé, dehors
                    imOut = true;
                  }
                } else { 
                  imOut = true;
                }
              }
            });

            if(!imOut) { // on a pas été exclus
              realBasePool.push(fdv);
            }


          } else { // pas de restriction, ajout du FDV
            realBasePool.push(fdv);
          }
        });

        // et on réinjecte
        basePool = realBasePool.filter(item => item.deprecated !== true);
        //#### fin FDV.restrict


        let meDS = new WizDatasource<FreedataValueVO>(basePool) // DS de la liste
                .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
                .setSelectionMode('multiple')
                .build();

        let fd: FreeDataVO = this.model.freedataEngine.getFreeData(key.code);
        let fdlevel: FreedataLevelVO = this.model.freedataEngine.getFreeDataLevel(fd, key.level);
          
        let master: GridsterWidget = this.currentMasters?.get(key.code);
        let columnDefs: WizColDef[] = this.buildColumns(master);

        let datas: generatorGridDatas = {
          wizDatasource: meDS,
          columnDefs: columnDefs,
          fdKey:  key.fullCode,
          fdLabel: fdlevel.trsLabel,
          parentWidget: master?.instance,
          requiredSize: this.getRequiredSize(columnDefs)
        }    

        // TODO extraire pour replay en cas de filtre sur un subChild
        
        if(!imSide) {
          this.gridMap.set(idx, datas);
          
        } else {
          this.sidegridMap.set(idx++, datas);
        }
        this.idxSet.add(idx);
        idx++;

        }
     }
   });

  }

 /**
   * actions jouées sur le drawContent, le alterContent, ou en cas de modifs de filtre, de sélection
   * @override
   * @param origin WIDGET_ACTION_ORIGIN pour cibler qui demande
   * @param data l'objet éventuellement porté
   */
 public drawOrRefresh(origin: WIDGET_ACTION_ORIGIN, data?: any): void {
   
  // console.log('generator drawOrRefresh', origin);

  let mustBuildRows: boolean = false; // on doit construire les lignes
  let mustFilter: boolean = false; // on doit appliquer les filtres
  // let mustBuildColumns: boolean = false; // on doit construire les colonnes
  let mustRefresh: boolean = false; // simple refresh sur recalcul

  // TODO TODO prendre en compte les masterWidgets et leur modif de pool / structure pour buildColumn et buildlines

  // première création
  if(origin === WIDGET_ACTION_ORIGIN.INIT) {
  }
  
  if(origin === WIDGET_ACTION_ORIGIN.READY) { // je me suis dit tout seul que j'étais prêt
    mustBuildRows = true;
    // mustBuildColumns = true;
    mustRefresh = true; 
  }

    // modification du pool de sélection sur un master
    if(origin === WIDGET_ACTION_ORIGIN.OUTER_SELECT) {
      // console.log('outer select', this.widgetKind, this.fei.uniqueName, this.state);
      mustBuildRows = true;
      mustFilter = true;
      mustRefresh = true;
    }


  if(mustFilter) {
    this.model.widgetEngine.refreshFilter(data ? data[0]: null); // reconstruction du filtre (symboliques)
    this.mainDS.refresh(); // on applique le filtre
    // dispatcher un event. Mes esclaves vont l'intercepter, j'impacte leur pool
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.WIDGET_UPDATED, this));
  }

  if(mustBuildRows) {
    this.buildLines(); // délégué au WidgetBasic
    // console.log('buildLines');
  }

  if(mustRefresh) {
  }

  // en cas de recréation des lignes (ajout sur override de scenar), repositionnement correct sur retour de commit
  if(this.model.widgetEngine.imLastFocus(this)) {
  }

  setTimeout(() => { // application du sort du grid (sur sortKeys) Timeout, sinon l'aggrid n'a pas encore construit ses colonnes
    this.cdRef.markForCheck();
  }, 0);
}


  /**
   * construction 'initiale' des objets graphiques du widget :
   * - sur init véritable
   * - sur modification de la datasource
   * - sur modification de scenario (modifie la DS)
   */
  public drawContent(): void {
    
    let masters: Map<string, IWidget> = this.model.widgetEngine.checkMasters(this); // je cherche un master. S'il y en a un, READY n'est pas suffisant
    
    let masterNotReady: boolean = false;
    // si j'ai un master et qu'il n'est pas prêt, on ne fait rien
    if (masters?.size > 0) { // j'ai un master, mais il n'est pas prêt
      [...masters.values()].forEach(iw => {
        if(!!iw && iw.state !== WIDGET_STATE.SELECTION_COMPLETE) {
          masterNotReady = true;
        }
      });
      
      // console.log('checkFeiState master not ready', this.widgetKind, this.fei.uniqueName);
      if(masterNotReady) {
        return;
      }
      
    }

    if(this.state >= WIDGET_STATE.READY) { // déjà construit, plus rien a faire
      return;
    }

    this.drawOrRefresh(WIDGET_ACTION_ORIGIN.INIT); // actions communes draw / alter
    super.drawContent(); // pas au début, c'est lui qui dispatch les events
  }

/**
 * construction 'initiale' des objets graphiques du widget :
 * - sur init véritable
 * - sur modification de la datasource
 * - sur modification de scenario (modifie la DS)
 */
// public drawContent(): void {
  

//   if(this.state >= WIDGET_STATE.READY) { // déjà construit, plus rien a faire
//     return;
//   }

//   this.drawOrRefresh(WIDGET_ACTION_ORIGIN.INIT); // actions communes draw / alter
//   super.drawContent(); // pas au début, c'est lui qui dispatch les events
// }

/**
 * reconstruction des objets graphiques du widget sur changement de structure : 
 * - modification des filtres qui impactent les colonnes
 * - changement de champs en ligne / colonnes / data
 * - changement de filtre
 * - changement de sélection
 * @param origin 
 */
public alterContent(origin: WIDGET_ACTION_ORIGIN): void {
  this.drawOrRefresh(origin);
  super.alterContent(origin);
}

  /* ##############################################################################
                    gestion de la popUp de configuration
     ############################################################################## */

  /**
   * @override IWidget : ouverture de la popUp de configuration (clic sur l'icone de conf)
   * override pour passer le mode de rendu grid / pivot
   * le retour est géré dans widget-basic (backFromSettingsPop)
   */
  public showSettingsPop(): void {
    this.settingsPopClassFactory = GeneratorSettingsPop;
    super.showSettingsPop();
  }


  public doMe(): void {
    // console.log('doMe');

    let cartesian: FreeDataCartesianBuilder = new FreeDataCartesianBuilder();

    // TODO prendre tous les IDs (clés gridMap & sideGridMap)
    // si side, aller chercher dans side APRES la coll

    

    let fdvs: any = {};

    // [...this.idxSet.keys()].forEach(idx => {
    //   if(this.gridMap.has(idx)) {
    //      fdvs[this.gridMap.get(idx).fdKey] = [];
    //     [...this.gridMap.get(idx).wizDatasource.selectedItems].forEach(fdv => {
    //       fdvs[this.gridMap.get(idx).fdKey].push(fdv.shortCode);
    //     });
    //   }
    // });

    // ajout des compléments 



    [...this.gridMap.keys()].forEach(idx => {
      fdvs[this.gridMap.get(idx).fdKey] = [];
      [...this.gridMap.get(idx).wizDatasource.selectedItems].forEach(fdv => {
        fdvs[this.gridMap.get(idx).fdKey].push(fdv.shortCode);
      });
    });

    if(this.sidegridMap.size > 0) {
      [...this.sidegridMap.keys()].forEach(idx => {
      fdvs[this.sidegridMap.get(idx).fdKey] = [];

      // TODO recherche dans fdvs pour prise des datas avec même base de key
      // prise des clés parents
      // et c'est fini... ?

      let children: FreedataValueVO[] = null;
      let key: string = this.sidegridMap.get(idx).fdKey;
      let smallKey: string = key.split(WizConstants.CONTEXT_SEPARATOR)[0];
      [...this.gridMap.values()].forEach(ggd => {
        if(ggd.fdKey.split(WizConstants.CONTEXT_SEPARATOR)[0] === smallKey) {
          let sourceRef: FreedataValueVO[] = ggd.wizDatasource.selectedItems;
          let sourceKeys: Set<string> = new Set(sourceRef.map(item => item.parentCode));

        [...this.sidegridMap.get(idx).wizDatasource.getSource()].forEach(fdv => {
          if(sourceKeys.has(fdv.code)) {
            fdvs[this.sidegridMap.get(idx).fdKey]
          }
          fdvs[this.sidegridMap.get(idx).fdKey].push(fdv.shortCode);
        });


        }
      });
    });
    }

 

    let steps: number[] = [] ; // this.tisteps.wizValue.split(ViewData.FILTER_ELEMENT_SEPARATOR);
    this.context.ct?.split(ViewData.FILTER_ELEMENT_SEPARATOR)?.forEach(idxStr => {
      steps.push(Number(idxStr));
    });

    let crit: any = {};
    this.context.cp?.forEach(wkp => {
      let code: string = wkp.cod;
      let vals: string[] = wkp.val?.toString()?.split(ViewData.FILTER_ELEMENT_SEPARATOR);

      crit[code] = vals;

    });
    // crit["HP#4@valor"] = ["P"];

    cartesian.vision = this.model.currentVision.source;
    cartesian.stepLevels = steps;
    cartesian.fdvs = fdvs;
    cartesian.criteria = crit;

    // console.log('cart', cartesian);

    new VisionManageLinesCmd(this.model)
      .cartesian(this.model.currentVision, steps, cartesian, this.backFromLineGeneration.bind(this))
      .execute();
  }

  private backFromLineGeneration(e: any) {
    this.model.compositeEngine.compositeCheck();
    // this.model.compositeEngine.compositeReload(); // si je modifie la vision en cours, je recharge les données
  }

  public toggleFilter(e: any): void {
    this.showAll = !this.showAll;
    this.buildLines();
    // console.log("toggleFilter", e, this.showAll);
  }


}

